import React 			from 'react'
import classnames 		from 'classnames'
import { connect }		from 'react-redux'
import renderHTML 		from 'react-render-html'
import { graphql } 		from 'gatsby'
import {
	get
} from 'lodash'

import PageArticle 		from '../components/page-article'

import breakpoints 		from '../lib/constants/breakpoints.json'
import {
	formatImageForARYImage
} from '../lib/_helpers'
import {
	InlineImageFragment,
	FileFragment
} from '../lib/fragments'

export default (props) => {
	const {
		data,
		location
	} = props

	return <PageArticle
		page={ data.page }
		location={ location }
		/>
}

export const query = graphql`
	query($id: String!) {
		page: wordpressPost(id: {eq: $id}){
			title
			slug
			wordpress_id
			acf {
				summary
				introduction
				main {
					display
					image {
						...ARYImageInline
					}
					video
					video_length
				}
				article_content_post {
					__typename
					... on WordPressAcf_article_text {
						heading
						body_copy
					}
					... on WordPressAcf_article_quote {
						quote
						name
						role
						quote_display
					}
					... on WordPressAcf_article_image {
						image {
							...ARYImageInline
						}
					}
					... on WordPressAcf_article_video {
						heading
						video
					}
					... on WordPressAcf_article_bubble_images {
						bubbles {
							image {
								...ARYImageInline
							}
						}
					}
				}
			}
			meta {
				endomag_reading_time
			}
		}
	}
`